import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class OrderContact extends DexResourceModel {

    @Field(String)
    public order_uuid: string = "";
    @Field(String)
    public contact_uuid: string = "";

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
